import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { SystemInputs } from "@graylog/server-api";
import FiltersForQueryParams from "components/common/EntityFilters/FiltersForQueryParams";
import { defaultOnError } from "util/conditional/onError";
const INITIAL_DATA = {
  pagination: { total: 0 },
  list: [],
  attributes: []
};
export const KEY_PREFIX = ["inputs", "overview"];
export const keyFn = (searchParams) => [...KEY_PREFIX, searchParams];
export const fetchInputs = (searchParams) => SystemInputs.getPage(
  searchParams.sort.attributeId,
  searchParams.page,
  searchParams.pageSize,
  searchParams.query,
  FiltersForQueryParams(searchParams.filters),
  searchParams == null ? void 0 : searchParams.sort.direction
).then((response) => ({
  list: response.elements,
  attributes: response.attributes,
  pagination: { total: response.total }
}));
const usePaginatedInputs = (searchParams, { enabled } = { enabled: true }) => {
  const { data, refetch, isLoading } = useQuery({
    queryKey: keyFn(searchParams),
    queryFn: () => defaultOnError(
      fetchInputs(searchParams),
      "Loading inputs failed with status",
      "Could not load inputs"
    ),
    placeholderData: keepPreviousData,
    enabled
  });
  return {
    data: data != null ? data : INITIAL_DATA,
    refetch,
    isLoading
  };
};
export default usePaginatedInputs;
